<template>
  <div class="dropdown" :class="{ expanded: isExpanded }">
    <div class="checkedItem" @click="toggleExpandHandler">
      <slot name="listItem" :option="currentOption || value"></slot>
      <img src="/img/arrow-down.svg" :class="{ expanded: isExpanded }" alt="Chevron" />
    </div>
    <transition name="el-zoom-in-top">
      <div v-show="isExpanded" class="menuList">
        <div
          v-for="item in filteredOptions"
          :key="`${item}`"
          class="menuListItem"
          @click="
            () => {
              listItemClickHandler(item);
            }
          "
        >
          <slot name="listItem" :option="item"></slot>
        </div>
      </div>
    </transition>
  </div>
</template>
<script setup lang="ts">
const props = defineProps<{
  options: unknown[];
  defaultValue?: unknown;
}>();

const value = ref(props.defaultValue);
const isExpanded = ref(false);
const emit = defineEmits(['handleChange']);

const currentOption = computed(() => {
  return props.options.find((option) => {
    if (option && typeof option === 'object' && 'key' in option) {
      return option.key === value.value;
    }

    return option === value.value;
  });
});

const filteredOptions = computed(() => {
  return props.options.filter((option) => {
    if (option && typeof option === 'object' && 'key' in option) {
      return option.key !== value.value;
    }
    return option !== value.value;
  });
});

const listItemClickHandler = (item: unknown) => {
  emit('handleChange', item);
  value.value = item as string;
  isExpanded.value = false;
};

const toggleExpandHandler = () => {
  isExpanded.value = !isExpanded.value;
};

watch(
  () => props.defaultValue,
  (tokenValue) => {
    value.value = tokenValue as string;
  }
);
</script>
<style lang="scss" scoped>
.dropdown {
  position: relative;
  width: 100%;
  border-radius: 12px;
  border: 2px solid #1e353e;
  background: radial-gradient(92.39% 62.21% at 84.01% 85.82%, #040f14 0%, #081b25 100%);
  box-shadow: 2px 4px 5px 0px rgba(0, 0, 0, 0.25);
  z-index: 9;
  cursor: pointer;

  &.expanded {
    border-radius: 12px 12px 0 0;
  }
}

.checkedItem {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  height: 80px;
}

.checkedItem img {
  width: 20px;
  height: 10px;

  &.expanded {
    transform: rotate(180deg);
  }
}

.menuList {
  position: absolute;
  top: 78px;
  left: -2px;
  width: calc(100% + 4px);
  border: 2px solid #1e353e;
  border-radius: 0 0 12px 12px;
  overflow-x: hidden;
  will-change: transform;
  transform: translateX(0);
}

.menuListItem {
  width: 100%;
  height: 80px;
  background: #06151c;
  display: flex;
  align-items: center;
  padding-left: 20px;

  &:not(:last-child) {
    border-bottom: 2px solid #1e353e;
  }
}
</style>

<style>
.el-zoom-in-top-enter-to {
  position: absolute !important;
  z-index: 9999 !important;
}
</style>
